import { render, staticRenderFns } from "./adminMain.vue?vue&type=template&id=50f2df7e&%3Akey=componentKey&"
import script from "./adminMain.vue?vue&type=script&lang=js&"
export * from "./adminMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports